// /home /help-center /profile /incentives
const umbrellaPaths = {
    home: '/home',
    helpCenter: '/help-center',
    incentives: '/incentives',
    profile: '/profile'
};
export default umbrellaPaths;
